import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function Ja(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="uploads3file">
                1.&nbsp;<span className="material-symbols-outlined">upload</span>&nbsp;{translate('uploads3file')}
            </Typography>
            <p><strong>{translate('uploads3file')}</strong> ファイルを AWS S3 にアップロードするアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>アップロードの保存先</td>
                                <td>$uploadS3File_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>AWS S3 接続の<strong>プロバイダー ID</strong> (接続方法は、 <Box component={Link} to="/control-center/documentation/connections/awss3">こちら</Box> をご参照ください。).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>アップロードするファイルのパスです。</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('bucketname')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>アップロードされたファイルが保存される AWS バケットのパス</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$uploadS3File_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>awss3-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/downloads/sktwi174l9kzzqc2/20221025-003483/combine.pdf</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('bucketname')}</span>
                            <div>data-test</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "ETag":'"2f502d2ca56c9086d63822e67762b4df\"',
                                            "ServerSideEncryption":"AES256",
                                            "VersionId":"B2q.NP_e44vGf_vliD46Iib2Mey4LopG",
                                            "Location":"https://data-all.s3.amazonaws.com/test/combine.pdf",
                                            "key":"test/combine.pdf",
                                            "Key":"test/combine.pdf",
                                            "Bucket":"data-test"
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="downloads3file">
                2.&nbsp;<span className="material-symbols-outlined">download</span>&nbsp;{translate('downloads3file')}
            </Typography>
            <p><strong>{translate('downloads3file')}</strong> AWS S3 からファイルをダウンロードするアクションです。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$downloadS3File_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>AWS S3 接続の<strong>プロバイダー ID</strong> (接続方法 <Box component={Link} to="/control-center/documentation/connections/awss3">こちら</Box> をご参照ください。).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('bucketname')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>バケットの名前</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>ダウンロードするファイルを保存する AWS バケットのパス</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$downloadS3File_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>awss3-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('bucketname')}</span>
                            <div>data-test</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/data/combine.pdf</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/downloads/sktwi174l9kzzqc2/20221025-003483/combine.pdf</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}

export default withTranslate(Ja);